import { useState, useCallback } from 'react';
import apiClient from '@/lib/apiClient';
import type { Diary } from '@/types';

/**
 * useDiaries — 旅行日记 Hook
 *
 * 注：原 Supabase travel_diaries 表已迁移到 MySQL，由 Backend API 操作。
 * 此 Hook 提供接口签名兼容层，内部通过 apiClient 调用后端。
 */
export const useDiaries = () => {
  const [diaries, setDiaries] = useState<Diary[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchDiaries = useCallback(async (_params: Record<string, unknown> = {}) => {
    setLoading(true);
    try {
      // TODO: 等待 Backend 实现 /api/v1/diaries 端点
      return [] as Diary[];
    } finally {
      setLoading(false);
    }
  }, []);

  const createDiary = useCallback(async (data: Partial<Diary>) => {
    // TODO: await apiClient.post('/diaries', data);
    return data;
  }, []);

  const updateDiary = useCallback(async (id: string, data: Partial<Diary>) => {
    // TODO: await apiClient.put(`/diaries/${id}`, data);
    setDiaries((prev) => prev.map((d) => (d.id === id ? { ...d, ...data } as Diary : d)));
  }, []);

  const deleteDiary = useCallback(async (id: string) => {
    // TODO: await apiClient.delete(`/diaries/${id}`);
    setDiaries((prev) => prev.filter((d) => d.id !== id));
  }, []);

  return { diaries, loading, fetchDiaries, createDiary, updateDiary, deleteDiary, setDiaries };
};

export default useDiaries;
